/**
 *
 * Module:        Library
 * Name:          Guru UI Language
 * Description:   Keeps the Guru interface in the browser language when historic chats are opened
 * Developers:    Adrian Engelmann, Kiran Jayaramu, Nicu Bratescu, Daniela Popescu
 * Copyright:     Copyright 2026 by Qalgo GmbH (www.qalgo.de). All rights reserved.
 *
 */

export const resolveGuruUiLanguage = ({
	chatConfigName,
	browserLanguages=[],
	browserLanguage='',
	chatLanguage=''
}) => {
	const primaryBrowserLanguage = Array.isArray(browserLanguages)
		? browserLanguages.find(language => typeof language === 'string' && language.trim())
		: '';
	const currentBrowserLanguage = primaryBrowserLanguage || browserLanguage;
	return chatConfigName === 'synapcus-chat-guru'
		? currentBrowserLanguage || chatLanguage || 'en'
		: chatLanguage || currentBrowserLanguage || 'en';
};
